import type { Notification } from "@src/packages/care/useNotifications";
import {
  getNotificationContract,
  parseNotificationData,
} from "./notification-contract";

export type NotificationRowPresentation = {
  title: string;
  body: string | null;
  metadata: string[];
  priority: ReturnType<typeof getNotificationContract>["priority"];
};

function readDisplayString(
  data: ReturnType<typeof parseNotificationData>,
  key: string,
) {
  const value = data[key];
  return typeof value === "string" && value.trim() ? value.trim() : null;
}

/**
 * Row content is intentionally producer-owned for copy, while the client may
 * add safe structured metadata when the payload contains it. This keeps the
 * feed useful for new server copy without inventing clinical interpretation.
 */
export function getNotificationRowPresentation(
  notification: Notification,
): NotificationRowPresentation {
  const data = parseNotificationData(notification.data);
  const metadata = [
    readDisplayString(data, "medicationName"),
    readDisplayString(data, "appointmentTime"),
    readDisplayString(data, "location"),
    readDisplayString(data, "dueDate"),
  ].filter((value): value is string => value !== null);

  return {
    title: notification.title || "Notification update",
    body: notification.body,
    metadata,
    priority: getNotificationContract(notification.type).priority,
  };
}
